import { NgModule, APP_INITIALIZER } from "@angular/core";
import { TranslatePipe } from "../language/translate.pipe";
import { TranslateService } from "./translate.service";
export function setupTranslateFactory(service: TranslateService): Function {
  return () => service.use("vi");
}

@NgModule({
  declarations: [TranslatePipe],
  exports: [TranslatePipe],
  providers: [
    TranslateService,
    {
      provide: APP_INITIALIZER,
      useFactory: setupTranslateFactory,
      deps: [TranslateService],
      multi: true
    }
  ]
})
export class TranslatePipeModule {}
